import { Container ,Row,Col,Image} from "react-bootstrap"
import ServiceCard from "./ServiceCard"
import './Style/Statistics.css'
function SerivceSection(){
    return(
        <>
 <Container className="p-4 pb-0" fluid style={{backgroundColor:"#f7f8fd"}}>

<div className="main">
    <span className="circle1"></span>
    <span className="circle2"> </span>
</div>
<div className="creative-shape" >
    <Image fluid className="creative-shape-img-2" src="./imgs/creative-circle-img.png" />
</div>
<Row className="gap-5 justify-content-center">
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/coding.png"  title="تصميم وتطوير المواقع."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/user-interface.png" title="تطوير تطبيقات الجوال (iOS و Android)."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/atom.png" title="تطوير تطبيقات الويب (React ، Angular ، Vue)."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/ui.png" title="تصميم UI / UX."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/graphic-designer.png" title="تصميم العلامة التجارية والشعار."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/seo.png" title="التسويق الرقمي (SEO ، PPC ، التسويق عبر وسائل التواصل الاجتماعي ، التسويق عبر البريد الإلكتروني)."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/shopping.png" title=" تطوير وتكامل مواقع التجارة الإلكترونية."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/content-creator.png" title="إنشاء المحتوى (كتابة المحتوى، إنتاج فيديو ، تصميم جرافيك)."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/cloud-data.png" title="الحوسبة السحابية (AWS و Azure و Google Cloud)."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/cyber-security.png" title="خدمات الأمن السيبراني وحماية البيانات."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/clipboard.png" title="استشارات تقنية المعلومات وإدارة المشاريع."/>
    </Col>
    <Col xs="12" md="4" lg="3" className="d-flex justify-content-center">
    <ServiceCard img="./imgs/virtual.png" title=" صيانة ودعم البرمجيات الاخرى."/>
    </Col>
    
</Row>
<Row className="flex-row-reverse">
                    <Col xs="2" className="p-0 d-flex justify-content-end">
                    <Image fluid className="" src="./imgs/service-shape.png"/>
                    </Col>
                </Row>
</Container>

        </>
       
    )
}

export default SerivceSection